import {Operation} from "./Operation.js";


export class Max extends Operation {

    static displayName() {
        return "Max";
    }

    static isNumeric() {
        return true;
    }

    static isCategorical() {
        return false;
    }

    static handlesDate() {
        return true;
    }

    incrementAggregation(newValue) {
        if (this.currValue === null) {
            this.currValue = newValue || 0;
        }
        this.currValue = Math.max(this.currValue, newValue);
    }

}

export default Max;
